import { atom } from 'recoil';

export const numberToBuy = atom({
  key: 'numberToBuy', // unique ID (with respect to other atoms/selectors)
  default: {
    number: '',
    rate: '',
    numType: '',
  },
  // default value (aka initial value)
});
